import { Controller } from "@hotwired/stimulus"
import { PushNotifications } from '@capacitor/push-notifications';

// Connects to data-controller="notifications"
export default class extends Controller {
  async request() {
    PushNotifications.requestPermissions().then((result) => {
      if (result.receive === 'granted') {
        // Register with Apple / Google to receive push via APNS/FCM
        PushNotifications.register();
      } else {
        Turbo.visit('/paywall');
      }
    });

    // On success, we should be able to receive notifications
    await PushNotifications.addListener('registration', (token) => {
      // alert('Push registration success, token: ' + token.value);

      const response = fetch('/push_tokens', {
        method: 'POST', headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          token: token.value,
        })
      });

      Turbo.visit('/paywall');
    });

    // // Some issue with our setup and push will not work
    // await PushNotifications.addListener('registrationError', (error) => {
    //   Turbo.visit('/stories');
    // });
    //
    // // Show us the notification payload if the app is open on our device
    // await PushNotifications.addListener('pushNotificationReceived', (notification) => {
    //   alert('Push received: ' + JSON.stringify(notification));
    // });
    //
    // // Method called when tapping on a notification
    // await PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
    //   alert('Push action performed: ' + JSON.stringify(notification));
    // });
  }
}
